export const CHAT_CONSTANTS = {
    STATE_DEBOUNCE_MS: 10,
    SCROLL_THRESHOLD_PX: 70,
    SCROLL_DELAY_MS: 450,
    MAX_MESSAGE_LENGTH: 2048,
    MAX_DISK_ATTACHMENTS: 100,
    SCROLL_INTERVAL_MS: 300,
    IDLE_TIMEOUT_MS: 15000,
} as const;

export const ICON_SIZES = {
    BUTTON_SIZE: 32,
    SVG_SIZE: 18,
    CITATION_BUTTON_HEIGHT: 36,
} as const;

// keep up with the File Format tokens from CSS theme
export const CHAT_ACCEPTED_FILE_FORMATS = [
    {name: 'text/plain', extension: 'txt'},
    {name: 'application/pdf', extension: 'pdf'},
    {name: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', extension: 'docx'},
    {name: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', extension: 'xlsx'},
    {name: 'application/vnd.openxmlformats-officedocument.presentationml.presentation', extension: 'pptx'},
    {name: 'application/msword', extension: 'doc'},
    {name: 'application/vnd.ms-excel', extension: 'xls'},
    {name: 'application/vnd.ms-powerpoint', extension: 'ppt'},
    {name: 'image/png', extension: 'png'},
    {name: 'image/jpeg', extension: 'jpeg'},
    {name: 'image/jpeg', extension: 'jpg'},
    {name: 'application/rtf', extension: 'rtf'},
] as const;